import React, { useState } from 'react';
import clsx from 'clsx';
import FAQ from './faq';
import { BaseComponentProps } from '@utils/types/baseComponents';
import styles from './styles.module.scss';

type Props = {
  faqs: {
    question: string;
    answerRaw: any;
  }[];
  noBorder?: boolean;
  highlightSelected?: boolean;
  title?: string;
  childClasses?: string;
} & BaseComponentProps;

const FAQs = (props: Props) => {
  const {
    faqs,
    noBorder,
    highlightSelected,
    childClasses = '',
    title,
    containerStyle,
    theme,
  } = props;
  const [selectedFAQ, setSelectedFAQ] = useState<number | null>(null);

  const onFAQClick = (index: number) => {
    if (index === selectedFAQ) {
      setSelectedFAQ(null);
    } else {
      setSelectedFAQ(index);
    }
  };

  return (
    <div className={clsx([styles.faqs, containerStyle])}>
      {title && <h2 className={styles.faqs__title}>{title}</h2>}

      {faqs.map((f, index) => (
        <FAQ
          {...f}
          index={index}
          selectedFAQ={selectedFAQ}
          onClick={onFAQClick}
          key={index}
          containerStyle={childClasses}
          highlightSelected={highlightSelected}
          noBorder={noBorder}
          theme={theme}
        />
      ))}
    </div>
  );
};

export default FAQs;
